<template>
  <div class="distributor-box">
    <!--tab栏-->
    <Tabs v-model="rulesType" :animated="false" class="tabs_styles" @on-click="changeTab">
      <template v-for="item in rulesTypeList">
        <TabPane v-if="item.listShow" :label="item.title" :name="item.type"></TabPane>
      </template>
    </Tabs>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <Button type="primary" v-if="handlePermissionKey('addPermissionKey')" @click="addRuleBtn">{{ $t('key1005441') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="560"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--库存同步规则弹窗-->
    <inventorySyncRulesModal
      ref="inventorySyncRules"
      :placeOfShipmentList="placeOfShipmentList"
      :platformList="platformList"
      @success="getList(rulesType)">
    </inventorySyncRulesModal>
    <!--商品状态同步规则弹窗-->
    <productStatusSyncRulesModal
      ref="productStatusSyncRules"
      :platformList="platformList"
      @updateData="getList(rulesType)">
    </productStatusSyncRulesModal>
    <!--价格同步规则弹窗-->
    <priceSyncRulesModal
      ref="priceSyncRules"
      :platformList="platformList"
      @updateData="getList(rulesType)">
    </priceSyncRulesModal>
    <!--YMS订单规则弹窗-->
    <ymsOrderSyncRulesModal
      ref="ymsOrderSyncRules"
      :platformList="platformList"
      @updateData="getList(rulesType)">
    </ymsOrderSyncRulesModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import inventorySyncRulesModal from '@/views/distributor/components/automaticRulesManage/inventorySyncRulesModal';
import productStatusSyncRulesModal from "@/views/distributor/components/automaticRulesManage/productStatusSyncRulesModal";
import priceSyncRulesModal from "@/views/distributor/components/automaticRulesManage/priceSyncRulesModal";
import ymsOrderSyncRulesModal from "@/views/distributor/components/automaticRulesManage/ymsOrderSyncRulesModal";
import {getDeliveryAreasAllData, getEnabledPlatforms, isAlibabaDistributor, setConfigCharacters} from "@/utils/common";

export default {
  name: 'automaticRules',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      rulesType: 'inventory',
      tableData: [],
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005419'),
          key: 'platformId',
          minWidth: 190,
          render(h, params) {
            let platformIdList = params.row.platformIdList || [];
            let text = platformIdList.length > 0 ? platformIdList.join('、') : '-';
            text === 'other' ? text = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005449')}` : text;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005619'),
          key: 'inventorySyncRulesName',
          minWidth: 300,
          render(h, params) {
            let text = v.availableText(params.row);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005620'),
          key: 'productStatusRuleName',
          minWidth: 300,
          render(h, params) {
            let productStatusRuleName = params.row.productStatusRuleName || [];
            if (productStatusRuleName.length > 0) {
              return h('div', {
                class: 'mt4 mb4',
                domProps: {
                  innerHTML: productStatusRuleName.join('<br/>')
                }
              });
            }
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005613')}`,
          key: 'ymsOrderRuleName',
          minWidth: 300
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005621'),
          key: 'storeName',
          minWidth: 200,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005622'),
          key: 'listingsTemplateName',
          minWidth: 200
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005623'),
          key: 'synTime',
          minWidth: 100,
          render(h, params) {
            let text = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005614')}${params.row.synTime}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005615')}`;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          minWidth: 90,
          render(h, params) {
            let status = params.row.status;
            return h('span', {
              style: {
                color: status === 1 ? 'green' : 'red'
              }
            }, status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005624') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 210,
          key: 'operation',
          align: 'center',
          render(h, params) {
            let ymsInventorySynRuleId = params.row.ymsInventorySynRuleId;
            let autoRuleId = params.row.autoRuleId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003503'),
                    show: v.handlePermissionKey('updatePermissionKey'),
                    clickFn: () => {
                      switch (v.rulesType) {
                        case 'inventory':
                          v.$refs['inventorySyncRules'].initAutomaticRulesData('edit', ymsInventorySynRuleId);
                          break;
                        case 'productStatus':
                          v.$refs['productStatusSyncRules'].initProductStatusSyncRulesData('edit', autoRuleId);
                          break;
                        case 'price':
                          v.$refs['priceSyncRules'].initPriceSyncRulesData('edit', autoRuleId);
                          break;
                        case 'ymsOrder':
                          v.$refs['ymsOrderSyncRules'].initYmsOrderSyncRulesData('edit', autoRuleId);
                          break;
                      }
                    },
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.handlePermissionKey('deletePermissionKey'),
                    clickFn: () => {
                      if (v.rulesType === 'inventory') {
                        v.deleteRulesBtn(params, ymsInventorySynRuleId);
                      } else {
                        v.deleteRulesBtn(params, autoRuleId);
                      }
                    },
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableColumns: [],
      placeOfShipmentList: [],
      rulesBaseList: [
        {
          type: 'inventory',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005625'),
          listPermissionKey: 'ymsInventorySynRule_queryAll',
          addPermissionKey: 'ymsInventorySynRule_insert',
          deletePermissionKey: 'ymsInventorySynRule_delete',
          updatePermissionKey: 'ymsInventorySynRule_update',
        },
        {
          type: 'productStatus',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005626'),
          listPermissionKey: 'ymsProductStatusSynRule_queryAll',
          addPermissionKey: 'ymsProductStatusSynRule_insert',
          deletePermissionKey: 'ymsProductStatusSynRule_delete',
          updatePermissionKey: 'ymsProductStatusSynRule_update',
        },
        {
          type: 'price',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005627'),
          listPermissionKey: 'ymsProductPriceSynRule_queryAll',
          addPermissionKey: 'ymsProductPriceSynRule_insert',
          deletePermissionKey: 'ymsProductPriceSynRule_delete',
          updatePermissionKey: 'ymsProductPriceSynRule_update',
        },
        {
          type: 'ymsOrder',
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`,
          listPermissionKey: 'ymsPackageInfoSynRule_queryAll',
          addPermissionKey: 'ymsPackageInfoSynRule_insert',
          deletePermissionKey: 'ymsPackageInfoSynRule_delete',
          updatePermissionKey: 'ymsPackageInfoSynRule_update',
        },
      ],
      platformList: [],
      publishStoreList: [], // 所有刊登店铺
      listingsTemplateList: [], //所有刊登模板
    };
  },
  computed: {
    // 处理tab栏数据
    rulesTypeList() {
      this.rulesBaseList.map((item) => {
        item['listShow'] = this.getPermission(item.listPermissionKey);
      });
      if (isAlibabaDistributor()) {
        let list = this.rulesBaseList.filter((item) => {
          return item.type !== 'ymsOrder';
        });
        return list;
      } else {
        return this.rulesBaseList;
      }
    }

  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化数据
    initFun() {
      let v = this;
      (async () => {
        await getEnabledPlatforms().then((data) => {
          v.platformList = data || [];
        });
        await getDeliveryAreasAllData().then((data) => {
          v.placeOfShipmentList = data;
        });
        await v.handleRulesData();
      })();
    },
    // 处理查询列表数据
    handleRulesData() {
      let v = this;
      let list = v.rulesTypeList.filter((item) => {
        return item.listShow;
      });
      if (list.length > 0) {
        v.rulesType = list[0].type;
        if (v.rulesType === 'price') {
          Promise.all([v.getListingPlatformStoreData(), v.getListingTemplateData()]).then(result => {
            if (result[0] && result[1]) {
              v.getList(v.rulesType);
            }
          });
        } else {
          v.getList(v.rulesType);
        }
      } else {
        v.gotoError();
      }
    },
    // 切换Tab栏
    changeTab(name) {
      let v = this;
      if (name === 'price') {
        Promise.all([v.getListingPlatformStoreData(), v.getListingTemplateData()]).then(result => {
          if (result[0] && result[1]) {
            v.getList(name);
          }
        });
      } else {
        v.getList(name);
      }
    },
    // 获取列表数据
    getList(type) {
      let v = this;
      v.tableData = [];
      v.optionBtnWidth = [];
      let obj = {
        inventory: api.get_ymsInventorySynRule_queryAll,
        productStatus: api.get_ymsProductStatusSynRule_queryAll,
        price: api.get_ymsProductPriceSynRule_queryAll,
        ymsOrder: api.get_ymsPackageInfoSynRule_queryAll,
      };
      let url = obj[type];
      v.handleColumns(type);
      v.tableLoading = true;
      v.axios.get(url).then(response => {
        if (response.data.code === 0) {
          let newList = response.data.datas || [];
          v.handleRuleData(newList, type);
          v.$forceUpdate();
        } else {
          v.tableLoading = false;
        }
      });
    },
    // 处理列表字段
    handleColumns(type) {
      let v = this;
      v.optionBtnWidth = [];
      let hideKeyColumns = [];
      let obj = {
        inventory: ['productStatusRuleName', 'ymsOrderRuleName', 'storeName', 'listingsTemplateName'],
        productStatus: ['inventorySyncRulesName', 'ymsOrderRuleName', 'storeName', 'listingsTemplateName', 'synTime'],
        price: ['productStatusRuleName', 'inventorySyncRulesName', 'ymsOrderRuleName', 'synTime'],
        ymsOrder: ['productStatusRuleName', 'inventorySyncRulesName', 'storeName', 'listingsTemplateName', 'synTime']
      };
      hideKeyColumns = obj[type] || [];
      v.tableColumns = v.originalColumns.filter((item) => {
        return !hideKeyColumns.includes(item.key);
      });
      v.updateTableDom('tableDom');
    },
    // 处理库存规则展示数据
    availableText(row) {
      let v = this;
      let params = row.ymsInventorySynRuleDetails ? JSON.parse(JSON.stringify(row.ymsInventorySynRuleDetails)) : [];
      if (params.length > 0) {
        params.forEach(i => {
          v.placeOfShipmentList.forEach(j => {
            if (i.ymsDeliveryPlaceId === j.ymsDeliveryPlaceId) {
              i.deliveryPlaceName = j.deliveryPlaceName;
            }
          });
        });
        let text = params.filter(i => i.ymsDeliveryPlaceId).reduce((a, b, index) => {
          if (index === 0) {
            a = b.deliveryPlaceName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243');
          } else {
            a = a + b.operator + b.deliveryPlaceName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243');
          }
          return a;
        }, 0);
        return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005616')}(${text}) *${100 - row.floatDown}%`;
      }
    },
    // 处理规则数据展示
    handleRuleData(newList, type) {
      let v = this;
      if (newList.length > 0) {
        newList.map((item) => {
          // 库存同步
          if (type === 'inventory') {
            let ymsInventorySynRulePlatforms = item.ymsInventorySynRulePlatforms || [];
            if (ymsInventorySynRulePlatforms.length > 0) {
              let platformIdList = ymsInventorySynRulePlatforms.map((item) => {
                return item.platformId;
              });
              item.platformIdList = platformIdList;
            }
          } else {
            item.platformIdList = [];
            item.productStatusRuleName = [];
            item.ymsOrderRuleName = null;
            let ruleActions = item.ruleActions || [];
            let ruleItems = item.ruleItems || [];
            if (ruleActions.length > 0) {
              ruleActions.map((ele) => {
                let obj = JSON.parse(ele.value);
                item.platformIdList = obj.platformId ? [obj.platformId] : [];
                // 商品状态同步
                if (ele.type === 'PRODUCT_STATUS_SYN_RULE') {
                  let ruleActionObj = {
                    syncinventoryToZero: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005628'),
                    syncproductToListing: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005629')
                  };
                  let ruleAction = obj.ruleAction || [];
                  if (ruleAction.length > 0) {
                    ruleAction.map((key) => {
                      item.productStatusRuleName.push(ruleActionObj[key]);
                    });
                  }
                }
                // 价格同步
                if (ele.type === 'PRODUCT_PRICE_SYN_RULE') {
                  // 店铺
                  if (v.publishStoreList.length > 0) {
                    v.publishStoreList.map((ele) => {
                      if (ele.saleAccountId === obj.shopId) {
                        item.storeName = ele.account;
                      }
                    });
                  }
                  // 模板
                  if (v.listingsTemplateList.length > 0) {
                    v.listingsTemplateList.map((ele) => {
                      if (ele.templateId === obj.templateId) {
                        item.listingsTemplateName = ele.templateName;
                      }
                    });
                  }
                }
              });
            }
            // YMS订单同步
            if (type === 'ymsOrder') {
              if (ruleItems.length > 0) {
                ruleItems.map((talg) => {
                  let ruleItemParams = talg.ruleItemParams || [];
                  if (ruleItemParams.length > 0) {
                    ruleItemParams.map((k) => {
                      if (k.name === 'boxedTimeOut') {
                        let ruleItemParamValues = k.ruleItemParamValues || [];
                        if (ruleItemParamValues.length > 0) {
                          ruleItemParamValues.map((j) => {
                            if (j.autoRuleItemParamId === k.autoRuleItemParamId) {
                              item.ymsOrderRuleName = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005617')}${j.value}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005618')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`;
                            }
                          });
                        }
                      }
                    });
                  }
                });
              }
            }
          }
        });
      }
      v.tableData = newList;
      v.$nextTick(() => {
        v.tableLoading = false;
      });
      v.$forceUpdate();
    },
    // 处理添加、修改、删除规则权限
    handlePermissionKey(type) {
      let talg = false;
      this.rulesBaseList.map((item) => {
        if (item.type === this.rulesType) {
          talg = this.getPermission(item[type]);
        }
      });
      return talg;
    },
    // 添加规则按钮
    addRuleBtn() {
      switch (this.rulesType) {
        case 'inventory':
          this.$refs['inventorySyncRules'].initAutomaticRulesData('add');
          break;
        case 'productStatus':
          this.$refs['productStatusSyncRules'].initProductStatusSyncRulesData('add');
          break;
        case 'price':
          this.$refs['priceSyncRules'].initPriceSyncRulesData('add');
          break;
        case 'ymsOrder':
          this.$refs['ymsOrderSyncRules'].initYmsOrderSyncRulesData('add');
          break;
      }
    },
    // 删除规则按钮
    deleteRulesBtn(params, id) {
      let v = this;
      switch (v.rulesType) {
        case 'inventory':
          handleUpdateData(api.delete_ymsInventorySynRule, id, params);
          break;
        case 'productStatus':
          handleUpdateData(api.delete_ymsProductStatusSynRule, id, params);
          break;
        case 'price':
          handleUpdateData(api.delete_ymsProductPriceSynRule, id, params);
          break;
        case 'ymsOrder':
          handleUpdateData(api.delete_ymsPackageInfoSynRule, id, params);
          break;
      }

      function handleUpdateData(url, id, params) {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000154'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005630'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.delete(url + id, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
              if (res.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
                v.tableData.splice(params.index, 1);
              }
            });
          },
          onCancel: () => {
          }
        });
      }
    },
    // 获取所有的刊登平台店铺数据
    getListingPlatformStoreData() {
      let v = this;
      return new Promise((resolve) => {
        let query = {
          platformId: null, // 不传平台ID默认获取所有平台的店铺
          status: 1 // 1'‑启用 '0'‑停用
        };
        v.publishStoreList = [];
        v.axios.post(api.post_ymsDistributorProductInfo_querySaleAccountInfoListByPlatform, query).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                let accountInfoList = item.accountInfoList || [];
                if (accountInfoList.length > 0) {
                  v.publishStoreList.push(...accountInfoList);
                }
              });
              resolve(data);
            }
          }
        });
      });
    },
    // 获取所有的刊登模板数据
    getListingTemplateData() {
      let v = this;
      return new Promise((resolve) => {
        let query = {
          platformId: null,
          saleAccountId: null,
          siteIds: []
        };
        v.listingsTemplateList = [];
        v.axios.post(api.post_ymsDistributorProductInfo_queryTemplateByPlatform, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              data.map((item) => {
                let templateInfoList = item.templateInfoList || [];
                if (templateInfoList.length > 0) {
                  v.listingsTemplateList.push(...templateInfoList);
                }
              });
              resolve(data);
            }
          }
        });
      });
    }
  },
  components: {
    inventorySyncRulesModal,
    productStatusSyncRulesModal,
    priceSyncRulesModal,
    ymsOrderSyncRulesModal
  }
};
</script>

<style scoped>

</style>
